import axios from "axios";
import { useCallback, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { Context } from "../../context/context";
import { auth } from "../../firebase/firebase.utils";
import { Spinner } from "../../components/ui";

const SignOut = () => {
  const { dispatch } = useContext(Context);
  const navigate = useNavigate();

  const handleLogout = useCallback(async () => {
    try {
      await auth.signOut();
      await axios.get("/app-api/user/logout");
    } catch (err) {
      console.error(err);
    } finally {
      // Always clear the local session, even if the round trip failed.
      window.sessionStorage.removeItem("user");
      dispatch({ type: "LOGOUT" });
      navigate("/signin");
    }
  }, [dispatch, navigate]);

  useEffect(() => {
    handleLogout();
  }, [handleLogout]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-canvas text-primary-600">
      <Spinner className="h-7 w-7" />
      <p className="text-sm font-medium text-gray-500">Signing out…</p>
    </div>
  );
};

export default SignOut;
